"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var account_1 = require("./account");
exports.Account = account_1.Account;
var adwords_1 = require("./adwords");
exports.Adwords = adwords_1.Adwords;
var business_1 = require("./business");
exports.Business = business_1.Business;
var calendar_1 = require("./calendar");
exports.Calendar = calendar_1.Calendar;
var docs_1 = require("./docs");
exports.Docs = docs_1.Docs;
var drive_1 = require("./drive");
exports.Drive = drive_1.Drive;
var gmail_1 = require("./gmail");
exports.Gmail = gmail_1.Gmail;
var plus_1 = require("./plus");
exports.Plus = plus_1.Plus;
var maps_1 = require("./maps");
exports.Maps = maps_1.Maps;
var news_1 = require("./news");
exports.News = news_1.News;
var photos_1 = require("./photos");
exports.Photos = photos_1.Photos;
var search_1 = require("./search");
exports.Search = search_1.Search;
var sheets_1 = require("./sheets");
exports.Sheet = sheets_1.Sheet;
var slides_1 = require("./slides");
exports.Slides = slides_1.Slides;
var translate_1 = require("./translate");
exports.Translate = translate_1.Translate;
var youtube_1 = require("./youtube");
exports.Youtube = youtube_1.Youtube;
